import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { API_BASE } from "../data/brand";

export function useLocations() {
  return useQuery({
    queryKey: ["locations"],
    queryFn: async () => (await axios.get(`${API_BASE}/locations`)).data,
    staleTime: 5 * 60 * 1000,
  });
}

export function useLocation(slug) {
  return useQuery({
    queryKey: ["location", slug],
    queryFn: async () => (await axios.get(`${API_BASE}/locations/${slug}`)).data,
    enabled: Boolean(slug),
  });
}
